import {
  Stack,
  TextField,
  Typography,
  Box,
  Button,
  Radio,
  Checkbox,
  FormControlLabel,
  MenuItem,
} from "@mui/material";
// Home Charging is temporarily disabled — HomeOutlinedIcon is no longer used.
// import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import { useFormikContext } from "formik";
import countries from "src/utils/countries.json";

const USE_CASES = [
  // Home Charging is temporarily disabled — only Business/Fleet is offered
  // right now. Uncomment to bring it back.
  // {
  //   value: "home",
  //   label: "Home Charging",
  //   description: "Personal home charging",
  //   icon: HomeOutlinedIcon,
  // },
  {
    value: "business",
    label: "Business / Fleet",
    description: "Professional charging management",
    icon: ApartmentOutlinedIcon,
  },
];

export default function AboutYouStep({
  onSubmit,
  onBackToLogin,
  readOnly = false,
  submitLabel = "Create Account",
}) {
  const { values, errors, touched, getFieldProps, setFieldValue } =
    useFormikContext();

  return (
    <Stack spacing={3}>
      <Box>
        <Typography variant="h6" fontWeight={600}>
          About You
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Tell us about yourself
        </Typography>
      </Box>

      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        <TextField
          fullWidth
          required
          label="First Name"
          placeholder="John"
          disabled={readOnly}
          {...getFieldProps("firstName")}
          error={Boolean(touched.firstName && errors.firstName)}
          helperText={touched.firstName && errors.firstName}
        />
        <TextField
          fullWidth
          required
          label="Last Name"
          disabled={readOnly}
          placeholder="Doe"
          {...getFieldProps("lastName")}
          error={Boolean(touched.lastName && errors.lastName)}
          helperText={touched.lastName && errors.lastName}
        />
      </Stack>

      <TextField
        fullWidth
        required
        label="Email Address"
        disabled={readOnly}
        placeholder="john@example.com"
        {...getFieldProps("email")}
        error={Boolean(touched.email && errors.email)}
        helperText={touched.email && errors.email}
      />

      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        <TextField
          fullWidth
          required
          label="Phone Number"
          placeholder="+1 555 123 4567"
          disabled={readOnly}
          {...getFieldProps("phoneNumber")}
          error={Boolean(touched.phoneNumber && errors.phoneNumber)}
          helperText={touched.phoneNumber && errors.phoneNumber}
        />
        <TextField
          fullWidth
          label="GST (Optional)"
          placeholder="GST number"
          disabled={readOnly}
          {...getFieldProps("gst")}
          error={Boolean(touched.gst && errors.gst)}
          helperText={touched.gst && errors.gst}
        />
      </Stack>

      <TextField
        select
        fullWidth
        required
        label="Country"
        disabled={readOnly}
        placeholder="Select Country"
        {...getFieldProps("country")}
        error={Boolean(touched.country && errors.country)}
        helperText={touched.country && errors.country}
      >
        {countries.map(({ value, label }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        fullWidth
        required
        label="Company Name"
        placeholder="Acme Inc."
        disabled={readOnly}
        {...getFieldProps("companyName")}
        error={Boolean(touched.companyName && errors.companyName)}
        helperText={touched.companyName && errors.companyName}
      />

      {/* <Box>
        <Typography variant="body2" fontWeight={600} sx={{ mb: 1.5 }}>
          How will you use Zynka? *
        </Typography>

        <Stack spacing={1.5}>
          {USE_CASES.map(({ value, label, description, icon: Icon }) => {
            const isSelected = values.useCase === value;
            return (
              <Box
                key={value}
                onClick={() => !readOnly && setFieldValue("useCase", value)}
                sx={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  p: 2,
                  borderRadius: "10px",
                  border: "1.5px solid",
                  borderColor: isSelected ? "primary.main" : "divider",
                  bgcolor: isSelected ? "action.selected" : "background.paper",
                  transition: "border-color 0.15s, background-color 0.15s",
                }}
              >
                <Radio
                  checked={isSelected}
                  size="small"
                  disabled={readOnly}
                  sx={{ p: 0 }}
                  onChange={() => setFieldValue("useCase", value)}
                />
                <Icon sx={{ color: "text.secondary" }} />
                <Box>
                  <Typography variant="body2" fontWeight={600}>
                    {label}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {description}
                  </Typography>
                </Box>
              </Box>
            );
          })}
        </Stack>
        {touched.useCase && errors.useCase && (
          <Typography
            variant="caption"
            color="error"
            sx={{ display: "block", mt: 0.5 }}
          >
            {errors.useCase}
          </Typography>
        )}
      </Box> */}

      {/* <Box>
        <FormControlLabel
          control={
            <Checkbox
              checked={values.acceptedTerms}
              disabled={readOnly}
              onChange={(e) => setFieldValue("acceptedTerms", e.target.checked)}
            />
          }
          label={
            <Typography variant="body2" color="text.secondary">
              I agree to the Terms of Service and Privacy Policy
            </Typography>
          }
        />
        {touched.acceptedTerms && errors.acceptedTerms && (
          <Typography variant="caption" color="error" sx={{ display: "block" }}>
            {errors.acceptedTerms}
          </Typography>
        )}
      </Box> */}

      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Button onClick={() => (window.location.href = "/login")} sx={{ color: "text.secondary" }}>
          Back to Login
        </Button>
        <Button variant="contained" onClick={onSubmit}>
          {submitLabel}
        </Button>
      </Stack>
    </Stack>
  );
}